import { render, staticRenderFns } from "./ListTaskMatter.vue?vue&type=template&id=781d1075"
import script from "./ListTaskMatter.vue?vue&type=script&lang=js"
export * from "./ListTaskMatter.vue?vue&type=script&lang=js"
import style0 from "./ListTaskMatter.vue?vue&type=style&index=0&id=781d1075&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports